import { Employee } from './SkillsInterfaces';

export interface Period {
  new_axsperiodid: string;
  new_name: string;
  statecode: number;
  statuscode: number;
}

export interface EmployeeGoal {
  cra0e_employeegoalid: string;
  cra0e_employee: Employee;
  new_period: Period;
  cra0e_description: string;
  cra0e_progresscomment: string;
  cra0e_evaluation: string;
  statecode: number;
  statuscode: number;
}

export interface GoalsPerStatus {
  draft: EmployeeGoal[];
  approved: EmployeeGoal[];
  inProgress: EmployeeGoal[];
  closed: EmployeeGoal[];
}

export enum GoalStatus {
  DRAFT = 1,
  INACTIVE_COMPLETED = 2,
  APPROVED = 100000000,
  IN_PROGRESS = 100000001,
  COMPLETED = 100000002,
  CANCELLED = 100000003,
  INACTIVE_CANCELLED = 100000004,
  DEFFERED = 100000005,
}

export enum StatusDisplayText {
  DRAFT = 'Waiting for approval',
  INACTIVE_COMPLETED = 'Inactive completed',
  APPROVED = 'Approved',
  IN_PROGRESS = 'In progress',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
  INACTIVE_CANCELLED = 'Inactive cancelled',
  DEFFERED = 'Deferred',
  CLOSED = 'Closed',
}
